export default __webpack_public_path__ + "static/media/separate-shapes.311aa7c7.svg";